module.exports = __webpack_public_path__ + "img/icon-x.fbda9a1a.svg";